"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.array = Array.isArray;
function primitive(s) {
    return typeof s === 'string' || typeof s === 'number';
}
exports.primitive = primitive;
//# sourceMappingURL=is.js.map


//////////////////
// WEBPACK FOOTER
// ./~/snabbdom/is.js
// module id = 5
// module chunks = 0